<template>
     <div class="home-view">
        <Topbar />
        <div class="m-auto col-md-6 pt-1">
            <div class="card mt-5">
                <div class="card-header text-white small p-0" :style="{ backgroundColor: moduloAtual().color }">
                    Movimentação Interna
                    <div v-show="carregando" class="spinner-grow">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div class="card-body p-1">
                    <select class="form-control form-control-sm" id="cliente">
                        <option value="">-- SELECIONE O CLIENTE --</option>
                        <option  v-for="(item) in this.clientes" :key="item.id" :value="item.id">{{ item.fantasia }}</option>
                    </select>

                    <div class="mt-2 small">
                        <InputDefaultApp
                            inputPlaceHolderSufixo="Digite o código de barras"
                            titleScan="Escanear Cód. Barras"
                            typeInputMode="numeric"
                            @displayScanFunction="buscarProduto"
                            :enterKey="(e) => buscarProduto(e.target.value)"
                            idInput="codigoBarrasInput"
                            :errorMessage="this.error"
                        >
                        </InputDefaultApp>
                    </div>
                   
                </div>
            </div>

            
            <div class="small" v-if="this.codigoBarrasConsultado">
                <table class="table table-bordered mb-0">
                        <thead style="background-color: gainsboro">
                            <th class="p-0">#</th>
                            <th class="p-0">Produto</th>
                        </thead>
                </table>
                <div class="scrollview mb-1">
                    <table class="table table-bordered mb-0 small">
                        <thead class="d-none">
                            <th class="p-0">#</th>
                            <th class="p-0">Produto</th>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in this.produtos" :key="item.idenderecamento">
                                <td class="p-1 text-center">
                                    <div class="p-0 pt-4">
                                        <input
                                        type="radio"
                                        name="selecionar"
                                        :value="JSON.stringify(item)"
                                        class="mt-5"
                                        onclick="document.getElementById('enderecoInput').focus();"
                                        >
                                    </div>
                                </td>
                                <td class="p-0 pl-1 text-left">
                                    <div class="row">
                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold">Endereco</div>
                                        <div class="col-7 col-md-7 col-lg-7">{{ item.descricao }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold">Qtde</div>
                                        <div class="col-7 col-md-7 col-lg-7">{{ item.qtde }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold">Lote</div>
                                        <div class="col-7 col-md-7 col-lg-7">{{ item.lote ? item.lote : "SEM LOTE" }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold">Validade</div>
                                        <div class="col-7 col-md-7 col-lg-7">{{ item.validade > 0 ? dateFormat(item.validade) : "SEM VALIDADE"}}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold">Valor R$</div>
                                        <div class="col-7 col-md-7 col-lg-7">{{ moneyFormat(item.valorcusto) }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold">Prod. Quarentena</div>
                                        <div class="col-7 col-md-7 col-lg-7">{{ item.prod_quarentena }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold">End. Quarentena</div>
                                        <div class="col-7 col-md-7 col-lg-7">{{ item.end_quarentena }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold">Pulmão</div>
                                        <div class="col-7 col-md-7 col-lg-7">{{ item.pulmao }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold">Qtde de Entrada</div>
                                        <div class="col-7 col-md-7 col-lg-7">{{ item.qtdeentrada }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-5 col-md-5 col-lg-5 font-weight-bold">Data Gravação</div>
                                        <div class="col-7 col-md-7 col-lg-7">{{ dateFormat(item.datagravacao) }}</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            
            </div>

            <div class="mt-5 text-center text-secondary" v-if="!this.codigoBarrasConsultado">
                <em class="fa fa-info-circle fa-3x mb-2"></em>
                <br>
                <span class="small">Bipe o código de barras do produto!</span>
            </div>

            <div class="card MT-0" v-if="this.codigoBarrasConsultado">
                <div class="card-header bg-success text-white small p-0">
                    Endereço de Destino
                </div>
                <div class="card-body p-1">

                    <div class="mt-0 small">
                        <InputDefaultApp
                            inputPlaceHolderSufixo="Digite o endereço destino"
                            titleScan="Escanear Endereço"
                            typeInputMode="text"
                            @displayScanFunction="buscarEndereco"
                            :enterKey="(e) => buscarEndereco(e.target.value)"
                            idInput="enderecoInput"
                            :errorMessage="this.enderecoDestinoErrorMessage"
                            :toUpperCase="true"
                        >
                        </InputDefaultApp>
                    </div>
                </div>
                <div class="card-footer pt-0 pb-0 border-top-0">
                    <div class="row">
                        <div class="col-6 col-md-6 col-lg-6 p-0 m-0 pr-1">
                            <button id="btnMovimentar" disabled class="btn btn-sm btn-block btn-success" @click="() => informarQuantidadeEMotivo()">
                                Movimentar
                                <em class="fa fa-random ml-2"></em>
                            </button>  
                        </div>
                        <div class="col-6 col-md-6 col-lg-6 p-0 m-0 mb-1 pl-1">
                            <button id="btnCancelar" class="btn btn-sm btn-block btn-danger" @click="() => clear()">
                                Cancelar
                                <em class="fa fa-ban ml-2"></em>
                            </button>  
                        </div>
                    </div>
                  
                </div>
            </div>
        </div>
        <LogoutModal />

        <Modal
            id="modal1"
            title="Confirme as informações:"
            :confirmFunction="() => movimentar()"
            :carregando="carregando"
            :cancelFunction="() => closeModal('modal1')"
        >
            <div class="small text-left">
                <label for="quantidade">* QTDE</label>
                <input id="quantidade" type="number" inputmode="numeric" class="form-control form-control-sm" value="1" min="0" autofocus>
                <label for="motivo" class="mt-2">* Motivo</label>
                <input id="motivo" inputmode="text" class="form-control form-control-sm" autocomplete="off" placeholder="Informe o motivo">
            </div>
        </Modal>

        <Modal
            id="modalRetorno"
            title="Sucesso"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="() => closeModal('modalRetorno')"
            cancelText="OK"
        >
            <div class="small text-center">
                <em class="fa fa-check-circle text-success fa-3x"></em>
                <br>
                <br>
                <span>{{ this.retornoMessage }}</span>
            </div>
        </Modal>
    </div>
</template>

<script>
import Topbar from '@/components/Topbar.vue'
import LogoutModal from '@/components/LogoutModal.vue'
import InputDefaultApp from '../components/InputDefaultApp.vue';
import ViewMixin from './ViewMixin'
import api, { getUserId } from '../services/api'
import { getUsername, getPerfil } from "../services/api";
import Modal from "../components/Modal.vue";
import $ from "jquery";
import { dateFormat, moneyFormat } from "../utils";
import audioService from '@/services/audioService.js';

export default {
    name: "MovimentacaoInterna",
    mixins: [
        ViewMixin
    ],
    computed: {
        username: function() {
            return getUsername().split(" ")[0];
        },
        perfil: function() {
            return getPerfil();
        },
    },

    components: {
        Topbar,
        LogoutModal,
        Modal,
        InputDefaultApp,
    },

    data: () => {
        return {
            clientes: [],
            produtos: [],
            scanAberto: false,
            codigoBarrasReferencia: null,
            codigoBarrasConsultado: false,
            enderecoDestinoErrorMessage: "",
            enderecoInformado: false,
            produtoSelecionado: null,
            enderecoDestino: null,
            error: null,
            retornoMessage: '',
        };
    },

    async mounted() {
        await this.getClientes();

        $("#cliente").change(() => {
            $("#codigoBarrasInput").focus();
        });
    },

    methods: {
        getUsername,
        getPerfil,
        dateFormat,
        moneyFormat,

        playSound() {
            audioService.ops();
        },

        closeModal(modalId) {
            $('#'+modalId).modal('hide');
            this.onModalClosed();
        },

        showMessageSuccess(message) {
            this.retornoMessage = message;
            $("#modalRetorno").modal('show');
        },

        onModalClosed() {
            let codigoBarrasInput = document.getElementById("codigoBarrasInput");
            let enderecoInput = document.getElementById("enderecoInput");

            if (codigoBarrasInput !== null && codigoBarrasInput !== undefined) {
                if (!codigoBarrasInput.disabled) {
                    codigoBarrasInput.focus();
                    codigoBarrasInput.select();
                }
            }
            if (enderecoInput !== null && enderecoInput !== undefined) {
                if (!enderecoInput.disabled) {
                    enderecoInput.focus();
                    enderecoInput.select();
                }
            }
        },

        async getClientes() {
            this.carregando = true;

            try {
                let response = await api.get("/cliente/listar");
                this.clientes = response.data;

                setTimeout(() => {
                    $("#codigoBarrasInput").focus();
                }, 250);
            } catch (e) {
                this.error = e.message;
                this.playSound();
            }

            this.carregando = false;
        },

        async buscarProduto(codigoBarras) {
            this.carregando = true;

            let idCliente = $('#cliente').val();
            if (idCliente.trim() === "") {
                this.carregando = false;
                this.error = "Selecione o cliente!";

                setTimeout(() => {
                    $("#codigoBarrasInput").focus();
                    $("#codigoBarrasInput").select();
                }, 250);
                this.playSound();

                return;
            }

            this.error = "";

            try {
                let response = await api.post("/movimentacao/produto/enderecos", {
                    idCliente: idCliente,
                    codigoBarras: codigoBarras
                });
                this.produtos = response.data;
                this.codigoBarrasConsultado = true;
                this.codigoBarrasReferencia = codigoBarras;

                setTimeout(() => {
                    document.getElementById('enderecoInput').focus();
                }, 1000);
            } catch (e) {
                this.error = e.message;
                this.codigoBarrasConsultado = false;

                setTimeout(() => {
                    $("#codigoBarrasInput").focus();
                    $("#codigoBarrasInput").select();
                }, 250);
                this.playSound();
            }

            this.carregando = false;
        },

        clear() {
            this.dados = null;
            this.codigoBarrasConsultado = false;
            this.enderecoDestinoErrorMessage = "";
            document.getElementById('codigoBarrasInput').value = "";
            document.getElementById('enderecoInput').value = "";
           
            document.getElementById("btnMovimentar").disabled = true;
            document.getElementById("btnCancelar").disabled = false;
            document.getElementById('codigoBarrasInput').disabled = false;
            document.getElementById('codigoBarrasInput').focus();
        },

        selectProduto() {
            let produtos = document.getElementsByName('selecionar');
            for (const p of produtos) {
                if (p.checked) {
                    this.produtoSelecionado = JSON.parse(p.value);
                }
            }
        },

        async buscarEndereco(endereco) {
            try {
                let response1 = await api.get("/movimentacao/endereco/"+btoa(endereco));

                if (JSON.stringify(response1.data).includes("descricao"))
                {   
                    if (response1.data.descricao === endereco) {
                        $("#enderecoInput").val(response1.data.descricao);
                        this.enderecoDestinoErrorMessage = "";
                        this.enderecoInformado = true;
                        document.getElementById("btnMovimentar").disabled = false;
                        this.enderecoDestino = response1.data;
                    }
                } else {
                    this.enderecoDestinoErrorMessage = "Endereço não encontrado!";
                    this.enderecoInformado = false;
                    $("#enderecoInput").focus();
                    $("#enderecoInput").select();
                    this.playSound();
                }
            } catch (e) {
                this.enderecoDestinoErrorMessage = "Endereço não encontrado!";
                this.enderecoInformado = false;
                $("#enderecoInput").focus();
                $("#enderecoInput").select();
                this.playSound();
            }
        },

        informarQuantidadeEMotivo() {
            if (!this.enderecoInformado) {
                this.enderecoDestinoErrorMessage = "Informe o endereço";
                $("#enderecoInput").focus();
                $("#enderecoInput").select();
                this.playSound();
                return;
            }

            this.selectProduto();
            if (this.produtoSelecionado === null) {
                this.enderecoDestinoErrorMessage = "Selecione um produto!";
                $("#enderecoInput").focus();
                $("#enderecoInput").select();
                this.playSound();
                return;
            }

            this.enderecoDestinoErrorMessage = "";
            $("#modal1").modal('show');
        },

        async movimentar() {

            this.carregando = true;

            let quantidade = document.getElementById('quantidade').value;
            let motivo = document.getElementById('motivo').value;

            if (quantidade == 0 ) {
                
                setTimeout(() => {
                    document.getElementById('quantidade').style.border = "1px solid red";
                    this.informarQuantidadeEMotivo();
                    this.playSound();
                }, 1000);
                
            } else if (motivo.trim() === "") {
                setTimeout(() => {
                    document.getElementById('motivo').style.border = "1px solid red";
                    this.informarQuantidadeEMotivo();
                    this.playSound();
                }, 1000);
            } else {
                try {
                    let body = {
                        enderecoOrigemId: this.produtoSelecionado.idenderecamento,
                        enderecoDestinoDescricao: document.getElementById('enderecoInput').value,
                        idProduto: this.produtoSelecionado.idprodutos,
                        idCliente: parseInt(document.getElementById('cliente').value),
                        idUsuario: parseInt(getUserId()),
                        motivo: motivo,
                        qtde: parseInt(quantidade)
                    };

                    document.getElementById('motivo').style.border = "1px solid #CCC";
                    document.getElementById('quantidade').style.border = "1px solid #CCC";
                    document.getElementById('motivo').value = "";
                    document.getElementById('quantidade').value = "";

                    this.closeModal("modal1");

                    let response = await api.post("/movimentacao/interna", body);

                    if (response.status === 200) {
                        this.buscarProduto(this.codigoBarrasReferencia);
                        document.getElementById('enderecoInput').value = "";
                        document.getElementById("btnMovimentar").disabled = true;
                        this.produtoSelecionado = null;
                        this.showMessageSuccess("Movimentação efetuada com sucesso!");
                        this.buscarProduto(this.codigoBarrasReferencia);
                    }
                } catch (e) {
                    this.error = e.message;
                    this.playSound();
                }      
            }

            this.carregando = false;
        }
    }
};
</script>

<style scoped lang="scss">   
    .icon-input {
        position: absolute;
        top: 20%;
        right: 30px;
        font-size: 18px;
    }

    .icon-cam {
        position: absolute;
        top: 20%;
        right: 5px;
        font-size: 18px;
    }

    .main {
        padding-top: 75px;
    }

    input[type=checkbox] {
        accent-color: #6C757D;
    }

    input[type=radio] {
        accent-color: #6C757D;
        transform: scale(1.5); /* Aumenta o tamanho do radio button em 50% */
    }

    .scrollview {
        overflow-y: auto;
        overflow-x: hidden;
        max-height: 180px;
    }

    @media (max-height: 840px) {
        .scrollview {
            max-height: 560px;
        }
    }

    @media (max-height: 800px) {
        .scrollview {
            max-height: 510px;
        }
    }

    @media (max-height: 768px) {
        .scrollview {
            max-height: 250px;
        }
    }

    @media (max-height: 700px) {
        .scrollview {
            max-height: 420px;
        }
    }

    @media (max-height: 680px) {
        .scrollview {
            max-height: 420px;
        }
    }

    @media (max-height: 640px) {
        .scrollview {
            max-height: 340px;
        }
    }

    @media (max-height: 600px) {
        .scrollview {
            max-height: 280px;
        }
    }

    @media (max-height: 580px) {
        .scrollview {
            max-height: 260px;
        }
    }

    @media (max-height: 540px) {
        .scrollview {
            max-height: 220px;
        }
    }

    @media (max-height: 500px) {
        .scrollview {
            max-height: 180px;
        }
    }

    @media (max-height: 475px) {
        .scrollview {
            max-height: 150px;
        }
    }

    @media (max-height: 470px) {
        .scrollview {
            max-height: 150px;
        }
    }
</style>